import _Vue from 'vue'
import Modal from './modal.vue'

export interface ModalInterface {
  open(items: string, params?: object): void
  close(items: string, params?: object): void
}

const Plugin = {
  installed: false as boolean,
  event: new _Vue(),

  install(Vue: typeof _Vue, options: object = {}) {
    if (this.installed) {
      return
    }

    this.installed = true

    Vue.prototype.$modal = {
      open(name: string, params: object) {
        Plugin.event.$emit('open', name, params)
      },

      close(name: string, params: object) {
        Plugin.event.$emit('close', name, params)
      },
    }

    Vue.component('vgb-modal', Modal)
  },
}

export default Plugin
